export default __webpack_public_path__ + "static/media/bg-who-use-section.6ee3bb94.webp";